export const updateState = (prevState, updatedState) => {
    return {
        ...prevState,
        ...updatedState
    };
};